import { render, staticRenderFns } from "./OpenConfirm.vue?vue&type=template&id=9e54cfb4&"
import script from "./OpenConfirm.vue?vue&type=script&lang=js&"
export * from "./OpenConfirm.vue?vue&type=script&lang=js&"
import style0 from "./OpenConfirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports